import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import CircleOfWaiting from 'components/shared/CircleOfWaiting'
import BotAvatar from 'shared-web/src/components/BotAvatar'
import styles from './style.styl'

const BotAvatarPreview = ({color, preview, style, loading = false}) => {
  if (loading) {
    return (
      <div className={classNames("bot-avatar", styles.BotAvatarPicker__Loading)}>
        <CircleOfWaiting />
      </div>
    )
  } else if (!!preview) {
    return (
      <div className={classNames("bot-avatar", styles.BotAvatarPicker__Preview)}
           style={{
               backgroundImage: `url(${preview})`,
               backgroundSize: "cover",
               backgroundPosition: "center",
               borderRadius: "50%",
               ...style,
             }}
      >
      </div>
    )
  } else {
    return(
      <BotAvatar className="bot-avatar"
                 color={`#${color}`}
                 style={style}
      />
    )
  }
}
BotAvatarPreview.propTypes = {
  color: PropTypes.string.isRequired,
  preview: PropTypes.string,
  loading: PropTypes.bool,
}

export default BotAvatarPreview



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Routing/BotAvatarPreview/index.js